import React from "react";
import { Box, Typography } from "@mui/material";
import TurnoCard from "./TurnoCard";

const sxTitulo = { fontWeight: 700, color: "#212529", mb: 2, textAlign: "center", fontSize: "clamp(1.25rem, 2.5vw, 2rem)" };
const sxRejilla = { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 2 };
const sxVacio = { color: "#6c757d", textAlign: "center", fontSize: "1.1rem" };

/**
 * Sección de la pantalla de turnos: título y rejilla de tarjetas (o texto si no hay turnos)
 */
const SeccionTurnos = ({ titulo, turnos, mostrarMostrador = false, mostrarDetalles = true, vacio }) => (
    <Box component="section">
        <Typography variant="h5" component="h2" sx={sxTitulo}>{titulo}</Typography>
        {turnos.length === 0 ? (
            <Typography sx={sxVacio}>{vacio}</Typography>
        ) : (
            <Box sx={sxRejilla}>
                {turnos.map((turno) => (
                    <TurnoCard key={turno.id} turno={turno} mostrarMostrador={mostrarMostrador} mostrarDetalles={mostrarDetalles} />
                ))}
            </Box>
        )}
    </Box>
);

export default React.memo(SeccionTurnos);
